import React, {useEffect, useState} from "react";
import { MyClaimsConversion } from ".";
import { MdSend, MdOutlineEmail, MdMessage } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import { AiFillVideoCamera } from "react-icons/ai";
import useUploadDocument from "../hooks/useUploadDoc";
import { useProject } from "../context/ProjectContext";
import { serverTimestamp } from "firebase/firestore";
import { auth } from "../firebase/firebase";
import { IoMdDocument } from "react-icons/io";
import VoiceRecorder from "./Media/VoiceRecorder";

const ProjectChat = () => {
  const [det, setDet] = useState(true)
  // const [act, setAct] = useState(false)
  const [fil, setFil] = useState(false)
  const inputRef = React.useRef(null);
  const [ content, setContent ] = useState("");
  const { onChange, doc, setUrl, onNewDoc } = useUploadDocument();
  const { addprojectnote, setLoading, details, selectedProject } = useProject();

  // const addMediaFile = (e) => {
  //   const mediaType = e.target.files[0].type;
  //   var type = mediaType.split("/")[0];
  //   onChange(e, 'claim', setLoading);
  //   const value = doc.url;
  //   sendChat(type,value);
  //   setUrl(null);
  // }

  const addMediaFile = (e) => {
    let mediaType;
    let type
    if (e.files) {
      mediaType = e.target.files[0].type;
      type = mediaType.split("/")[0];
      onChange(e, 'project', setLoading);
    } else {
      mediaType = e.type;
      type = mediaType.split("/")[0];
      onNewDoc(e, 'project', setLoading)
    }
    sendChat(type, doc.url)
    setUrl(null);
  }

  useEffect(() => {
    if (auth?.currentUser?.uid) {
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  const sendChat = (type, content) => {
    addprojectnote({ type: type, note: content, createdAt: serverTimestamp() });
  }
  const handleSend = () => {
    const value = inputRef.current.value;
    setContent(value);
    sendChat("message", content)
    inputRef.current.value = "";
  };

  const onClick = (type) => {
    switch (type) {
      // case 'activity':
      //   setDet(false);
      //   setFil(false);
      //   setAct(true);
      //   break;
      case 'details':
        setDet(true)
        setFil(false)
        // setAct(false)
        break;
      case 'files':
        setDet(false)
        setFil(true)
        // setAct(false)
        
        break;
      default:
        return
    }
  }

  return (
    <div className="border-2 rounded-xl mt-3 mb-5 h-[85%] flex flex-col justify-between">
      {Object.keys(selectedProject).length > 0 && <>
        <div className="border-b-2 py-3 mb-3 px-5 flex justify-between items-center">
          <div className="flex items-center gap-4">
            {selectedProject?.media.length > 0 ?
              (<img className="h-12 w-12 rounded-full" src={selectedProject?.media[0]} alt="" />) :
              (<div className="py-3 px-3 rounded-full broder broder-gray-300">
                <IoMdDocument />
              </div>)
            }
            <div>
              <p className="text-sm font-semibold">{selectedProject?.contractor?.contractorName}</p>
              <p className="text-xs text-primary">
                Contractor - last update {selectedProject?.lastUpdate}
              </p>
            </div>
          </div>
          <div className="p-3 rounded-full bg-[#0dc143]">
            <BsWhatsapp className="text-3xl text-white" />
          </div>
        </div>

        <div className="h-[69%] overflow-auto scrollbar-hide px-5">
          <div className="flex items-center justify-center pb-20 ">
            <div className="flex items-center gap-10 bg-[#d6ecfb] border-2 border-primary py-1 px-10 rounded text-primary text-sm">
              <p onClick={() => onClick("details")} className={`cursor-pointer ${det && 'bg-primary transition text-white px-3 py-1 rounded'}`}>Details</p>
              <p onClick={() => onClick("files")} className={`cursor-pointer ${fil && 'bg-primary transition text-white px-3 py-1 rounded'}`}>Files</p>
            </div>
          </div>

          {details?.length > 0 ? (
            details?.map((item, key) => {
              return (
                <div className="mb-4" key={key}>
                  {item?.type === "message" ? (
                    <p className="text-xs border-2 rounded-xl p-4 mb-2 mx-5">{item?.note}</p>
                  ) : (
                    <MyClaimsConversion key={key} item={item} note={item?.note} type={item?.type} />
                  )}
                  <p className="text-[10px] mx-5">
                    {item?.date ? JSON.stringify(item?.date?.toDate()).replace(/['"]+/g, "") : new Date().toISOString()}
                  </p>
                </div>
              );
            })
          ) : (
            <div className="flex justify-center items-center h-96">
              <p className="text-center text-gray-400">No notes found</p>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between px-5 py-2 border-t-2">
          <div className="flex items-center justify-between border-2 border-primary px-2 py-1 w-[65%] rounded-lg">
            <input
              ref={inputRef}
              type="text"
              onKeyDown={(e) => {
                if (e.code === "Enter") {
                  handleSend();
                }
              }}
              placeholder="Write a New Note"
              className="w-[60%] focus:outline-none"
            />
            <div className="bg-[#f5f5f5] p-2 rounded-md cursor-pointer">
              <MdSend className="text-primary" onClick={handleSend} />
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex flex-col items-center justify-center pl-2">
              <div className="p-[5px] rounded-full text-primary text-xl cursor-pointer">
                <VoiceRecorder onRecorded={addMediaFile} />
              </div>
              <p className="text-[7px] text-primary font-medium">Record Audio</p>
            </div>
            <div className="flex flex-col items-center justify-center  pl-2">
              <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                <label htmlFor="mediaUpload">
                  <AiFillVideoCamera />
                </label>
              </div>
              <input
                id="mediaUpload"
                type="file"
                accept="image/*, video/*"
                className="w-0.1 h-0.1 overflow-hidden hidden"
                onChange={addMediaFile}
              />
              <p className="text-[7px] text-primary font-medium">Add Video</p>
            </div>
            <div className="flex flex-col items-center justify-center pl-2">
              <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                <MdOutlineEmail />
              </div>
              <p className="text-[7px] text-primary font-medium">Send Email</p>
            </div>
            <div className="flex flex-col items-center justify-center pl-2">
              <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                <MdMessage />
              </div>
              <p className="text-[7px] text-primary font-medium">Send SMS</p>
            </div>
          </div>
        </div>
      </>}
    </div>
  );
};

export default ProjectChat;
